const headMeta = {
  siteName: 'Bode Canada',
  type: 'website',
  domain: 'https://bode.ca',
};

export default headMeta;
